//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Marshall',
  data() {
    return {
      form:{
        pao2fio2:'',
        crea:'',
        sbp:'1',
        sbp_fluid:'0',
        ph:'',
      },
      defaultJson:{
        "Respiratory (PaO₂/FiO₂)": "呼吸（PaO₂/FiO₂）",
        "Respiratory Organ Failure": "呼吸器官衰竭",
        "Cardiac Organ Failure": "心脏衰竭",
        "No Organ Failure": "无器官衰竭",
        "Renal Organ Failure": "肾脏衰竭",
        "Serum Creatinine": "血肌酐",
        "Systolic BP Fluid Responsive": "收缩压输液反应",
        "Systolic BP >=90 mmHg": "收缩压 >=90 mmHg",
        "pH": "pH",
        "Organ Failure": "器官衰竭"
      },
      hasScore:false,
      disabled:false,
      respiratory:'',
      renal:'',
      cardiac:'',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form.sbp=='1') {
        form.sbp_fluid='0'
        form.ph='0'
      }

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        
        // (pao2fio2 > 400 ? 0 : (pao2fio2 > 300 ? 1 : (pao2fio2 > 200 ? 2 : (pao2fio2 > 100 ? 3 : 4))))
        self.respiratory = (form.pao2fio2 > 400 ? 0 : (form.pao2fio2 > 300 ? 1 : (form.pao2fio2 > 200 ? 2 : (form.pao2fio2 > 100 ? 3 : 4))))
        // (crea < 135 ? 0 : (crea < 170 ? 1 : (crea < 311 ? 2 : (crea < 440 ? 3 : 4))))
        self.renal = (form.crea < 135 ? 0 : (form.crea < 170 ? 1 : (form.crea < 311 ? 2 : (form.crea < 440 ? 3 : 4))))
        // (sbp ? 0 : ((ph < 7.2 ? 4 : (ph < 7.3 ? 3 : (sbp_fluid ? 1 : 2))))
        self.cardiac = form.sbp ? 0 : ((form.ph < 7.2 ? 4 : (form.ph < 7.3 ? 3 : (form.sbp_fluid ? 1 : 2))))
        // (respiratory >=2 ? 1 : (renal >=2 ? 1 : (cardiac >=2 ? 1 : 0)))
        console.log('self.respiratory', self.respiratory);
        console.log('self.renal', self.renal);
        console.log('self.cardiac', self.cardiac);
        let result = self.respiratory >= 2 ? 1 : (self.renal >= 2 ? 1 : (self.cardiac >= 2 ? 1 : 0))
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/Marshall.vue